module.exports = __webpack_public_path__ + "img/check-circle.f619b582.svg";